<script>
	import { listenForTexts, listenForSounds } from '$lib/utilities';
	import { focusTrap } from '$lib/focusTrap';
	import { browser } from '$app/environment';
	import { fly, fade } from 'svelte/transition';
	import { onMount, onDestroy } from 'svelte';

	export let small = false;
	export let buttonBar = false;
	export let buttonBarSmall = false;
	export let pin = false;
	export let bottom = false;

	onMount(() => {
		if (browser) {
			document.body.classList.add('modal-open');
		}
	});

	onDestroy(() => {
		if (browser) {
			document.body.classList.remove('modal-open');
		}
	});
</script>

<div
	use:focusTrap
	use:listenForTexts
	use:listenForSounds
	class:pin
	class:small
	transition:fade|global={{ duration: 200 }}
	class="modal-wrap fixed z-[100] inset-y-0 inset-x-0 app-view"
>
	<div
		class:buttonBar
		class:buttonBarSmall
		class="app-overlay fixed left-0 {bottom
			? 'bottom-0'
			: 'top-0'} w-full h-full p-[3%] border-theme_white"
		transition:fly={{ y: bottom ? 800 : -800, duration: 750 }}
	>
		<div
			class="outer-frame max-w-[570px] mx-auto h-full bg-theme_teal border-[3px] rounded-3xl p-2"
		>
			<div class="inner-frame app-frame h-full border-[3px] rounded-2xl relative">
				<slot />
			</div>
		</div>
	</div>
</div>

<style>
	.outer-frame {
		box-shadow: 0 4px 16px 0 rgb(0 0 0 / 0.7);
	}

	.inner-frame {
		box-shadow: inset 0 4px 12px 0 rgb(0 0 0 / 0.2);
	}

	.buttonBar .inner-frame {
		padding-bottom: 4.5rem;
	}

	.buttonBarSmall .inner-frame {
		padding-bottom: 3.5rem;
	}

	.modal-wrap {
		background-color: rgba(0, 0, 0, 0.5);
	}

	.pin {
		z-index: 110;
	}

	.small {
		z-index: 105;
	}

	.small .app-overlay {
		height: auto;
	}

	.small .outer-frame {
		width: fit-content;
		max-width: 32rem;
	}
</style>
